// Node-style CommonJS imports expose Babel's default export inside module.exports.
export function interopDefault<T>(module: T | { default: T }): T {
  if (
    module !== null &&
    (typeof module === "object" || typeof module === "function") &&
    "default" in module
  ) {
    return module.default as T;
  }
  return module as T;
}
